export default __webpack_public_path__ + "static/image-highlight-baremetal-status-0960d2980592f310df0fd30ce6eba181.png";